import { render } from "./TransitionExpand.vue?vue&type=template&id=d0d453ee"
import script from "./TransitionExpand.vue?vue&type=script&lang=js"
export * from "./TransitionExpand.vue?vue&type=script&lang=js"

import "./TransitionExpand.vue?vue&type=style&index=0&id=d0d453ee&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__